<template>
    <div class=" section_sectionWrapper">
        <div class="module-sl">
            <div class="sl-cont">
                <div class=" w100 h100">
                    <swiper :options="slSilderOptions" ref="slSilderOptions" class="sl-swiper">
                        <swiper-slide v-for="i in 5" :key="i">
                            <div class="img-size">
                                <img :src="require('../../assets/img/sl-role/sl-0' + i + '.png')" alt="">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination-sl"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',


    data() {
        let that = this;
        return {
            slSilderOptions: {
                loop: true,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                allowTouchMove: false,
                noSwiping: false,
                noSwipingClass: "stop-swiping",
                initialSlide: 0,
                pagination: {
                    el: ".swiper-pagination-sl",
                    touchRatio: 1, //解决滑动卡顿
                    longSwipesRatio: 0.1,
                    threshold: 10, //如果触摸距离小于该值滑块不会被拖动
                    followFinger: false,
                    bulletClass: "my-swiper", //需设置.my-bullet样式
                    bulletActiveClass: 'my-swiper-active',
                    clickable: true, // 允许点击小圆点跳转
                    autoplayDisableOnInteraction: false,

                    renderBullet: function (index, className) {
                        switch (index) {
                            case 0:
                                name = "";
                                break;
                            case 1:
                                name = "";
                                break;
                            case 2:
                                name = "";
                            case 3:
                                name = "";
                            default:
                                name = "";
                        }
                        return (
                            '<div class="' +
                            className +
                            " " +
                            className +
                            [index] +
                            '"><i>' +
                            name +
                            "</i></div>"
                        );
                    },
                },



            },
        }
    },
    watch: {


    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.module-sl {
    position: relative;
    height: 100%;
    width: 100%;

    .sl-cont {
        width: 1412px;
        height: 727px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 45%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
        }

        /deep/ .swiper-pagination-sl {

            width: 1154px;
            height: 43px;
            background: url("../../assets/img/sl-role/sl-qh.png") no-repeat top;
            background-size: 100% 100%;
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            bottom: -50px;
            display: flex;
            align-items: start;

            .my-swiper {
                display: inline-block;
                width: 32px;
                height: 32px;
                cursor: pointer;
                position: absolute;
                top: -7px;
            }
            .my-swiper.my-swiper-active {
                background: url("../../assets/img/sl-role/active-sl.png") no-repeat top;
                background-size: 100% 100%;
            }

            .my-swiper0 {
                left:152px;
            }
            .my-swiper1 {
                left: 328px;
            }
            .my-swiper2 {
                left: 556px;
            }
            .my-swiper3 {
                right: 352px;
            }
            .my-swiper4 {
                right: 173px;
            }



        }
    }
}
@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-sl {
    .sl-cont  {
      width:1270px !important;
      height: 654px !important;
      top: 45% !important;
    }
  
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slPage.vue